import {
  // Initialization
  UPDATE_STATE_WITH_FETCHED_REPORT,
  UPDATE_STATE_WITH_FETCHED_COLUMNS,
  // onChanges
  ON_REPORT_NAME_CHANGE,
  ON_REPORT_DESCRIPTION_CHANGE,
  ON_REPORT_TYPE_CHANGE,
  ON_REPORT_SORT_CHANGE,
  ON_COLUMNS_CHECKBOX_CHANGE,
  // Validation + Saving
  ON_VALIDATE_FORM_STARTED,
  ON_VALIDATE_FORM_SUCCESS,
  ON_VALIDATE_FORM_ERROR,
  ON_REPORTS_SAVE_SUCCESS,
  ON_REPORTS_SAVE_ERROR,
  // Filters+Sorts+Events
  ON_SORT_ALPHABETICALLY_CHANGE,
  ON_SORT_BY_DATE_CHANGE,
  ON_REPORT_SAVE_DATE_OF_ORDER,
  ON_REPORT_SAVE_DATE_OF_ATTENDING,
  ON_REPORTS_SET_CUSTOM_EVENTS,
  // Schedule
  ON_REPORT_SCHEDULER_TIME_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN,
  ON_REPORT_SCHEDULER_FREQUENCY_CHANGE,
  ON_REPORT_SCHEDULER_TOGGLE,
  ON_REPORT_SCHEDULER_HOUR_CHANGE,
  ON_REPORT_SCHEDULER_DAY_CHANGE,
  // Misc
  CHECK_ALL_CHECKBOXES,
  ON_SCROLL_DONE,
} from '../actions';

const initialState = {
  loading: false,
  updatedStateSuccessfully: {
    report: false,
    columns: false
  },
  allBoxesChecked: false,
  firstLoad: true,
  isSaving: false,
  doScroll: false,
  requestType: 'POST',
  id: '',
  name: '',
  description: '',
  type: {
    label: '',
    id: 'attendeesReport',
    value: 'AttendeesReport',
  },
  columns: [],
  validator: {
    valid: false,
    data: {}
  },
  schedule: {
    from: undefined,
    to: undefined,
    enabled: false,
    interval: '',
    day: '',
    hour: ''
  },

  // to populate initial elements
  options: {
    types: [{
      label: '',
      id: 'attendeesReport', // Tickets Report
      value: 'AttendeesReport',
    }, {
      label: '',
      id: 'addOnsReport', // AddOns Report
      value: 'AddOnsReport',
    }, {
      label: '',
      id: 'ordersReport', // Orders Report
      value: 'OrdersReport',
    }]
  },
  order: 'created_at__desc'
};

const ORDERS_REPORT = 'ordersReport';

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    default: return state;

    // Initialization
    case UPDATE_STATE_WITH_FETCHED_REPORT: {
      return {
        ...state,
        requestType: 'PUT',
        updatedStateSuccessfully: {
          ...state.updatedStateSuccessfully,
          report: true
        },
        id: action.payload.fetchedReport.id,
        name: action.payload.fetchedReport.name,
        type: state.options.types.find(t => t.value === action.payload.fetchedReport.reportType),
        description: action.payload.fetchedReport.description,
        columns: action.payload.fetchedReport.columns,
        order: action.payload.fetchedReport.order
      };
    }
    case UPDATE_STATE_WITH_FETCHED_COLUMNS: {
      const fc = action.payload.fetchedColumns;
      const _columns = state.columns.map(c => {
        let _obj = {};
        Object.keys(fc).some(k => {
          if (fc[k].column === c) {
            _obj = fc[k];
            return true;
          }
        });
        return _obj;
      });

      return {
        ...state,
        updatedStateSuccessfully: {
          ...state.updatedStateSuccessfully,
          columns: true
        },
        columns: _columns
      };
    }

    // onChanges
    case ON_REPORT_NAME_CHANGE: {
      return {
        ...state,
        name: action.payload
      };
    }
    case ON_REPORT_DESCRIPTION_CHANGE: {
      return {
        ...state,
        description: action.payload
      };
    }
    case ON_REPORT_TYPE_CHANGE: {
      let reportOrder = state.order;
      if (state.order.indexOf('name') !== -1) {
        if (state.type.id === ORDERS_REPORT && action.payload.id !== ORDERS_REPORT) {
          reportOrder = reportOrder.replace('buyer_', '');
        }
        else if (state.type.id !== ORDERS_REPORT && action.payload.id === ORDERS_REPORT) {
          reportOrder = 'buyer_' + reportOrder;
        }
      }

      return {
        ...state,
        firstLoad: false,
        allBoxesChecked: false,
        type: action.payload,
        order: reportOrder
      };
    }
    case ON_REPORT_SORT_CHANGE: {
      return {
        ...state,
        order: action.payload.value
      };
    }
    case ON_COLUMNS_CHECKBOX_CHANGE: {
      return {
        ...state,
        columns: action.payload
      };
    }

    // Validation + Saving
    case ON_VALIDATE_FORM_STARTED:{
      const {
        name,
        type,
        columns,
      } = state;

      return {
        ...state,
        validator: {
          valid: Boolean(name && type && columns.length),
          data: {
            name: Boolean(!name),
            type: Boolean(!type),
            columns: Boolean(!columns.length),
          }
        }
      };
    }
    case ON_VALIDATE_FORM_SUCCESS:{
      return {
        ...state,
        isSaving: true
      };
    }
    case ON_VALIDATE_FORM_ERROR:{
      return {
        ...state,
        doScroll: true
      };
    }
    case ON_REPORTS_SAVE_SUCCESS:
    case ON_REPORTS_SAVE_ERROR: {
      return {
        ...state,
        isSaving: false
      };
    }
    // Filters+Sorts
    case ON_SORT_ALPHABETICALLY_CHANGE:
    case ON_SORT_BY_DATE_CHANGE:
    case ON_REPORT_SAVE_DATE_OF_ORDER:
    case ON_REPORT_SAVE_DATE_OF_ATTENDING:
    case ON_REPORTS_SET_CUSTOM_EVENTS: {
      return {
        ...state
      };
    }
    // Misc
    case CHECK_ALL_CHECKBOXES: {
      const fc = action.payload;
      const _columns = [];

      Object.keys(fc).forEach((k) => {
        _columns.push(fc[k]);
      });

      return {
        ...state,
        allBoxesChecked: true,
        columns: _columns,
        doScroll: true
      };
    }
    case ON_SCROLL_DONE: {
      return { ...state, doScroll: false };
    }

    // Schedule updates
    case ON_REPORT_SCHEDULER_TIME_CHANGE:
    case ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE:
    case ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE:
    case ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN:
    case ON_REPORT_SCHEDULER_FREQUENCY_CHANGE:
    case ON_REPORT_SCHEDULER_TOGGLE:
    case ON_REPORT_SCHEDULER_HOUR_CHANGE:
    case ON_REPORT_SCHEDULER_DAY_CHANGE: {
      return { ...state };
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/custom-general.js